import { useState, useMemo, useCallback, useContext } from 'react';
// import ReactEcharts from 'echarts-for-react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts';
import TypeChangeBtnGroup from '@/components/type_change_btn_group/TypeChangeBtnGroup';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import { transNum } from '@/utils/comUtil';
import { useIntl } from 'umi';

import { LineChart } from 'echarts/charts';
import dayjs from 'dayjs';
import {
  // GridSimpleComponent,
  // GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  // TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  // LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  // DataZoomComponent,
  // DataZoomInsideComponent,
  // DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from 'echarts/components';
import {
  CanvasRenderer,
  // SVGRenderer,
} from 'echarts/renderers';
import { mulTimeDimensionMulIndexMulValue } from '@/utils/reportResponseUtil';

echarts.use([TitleComponent, CanvasRenderer, LineChart]);

// 图表容器样式与坐标轴格式化函数提到模块级，保证引用稳定，
// 避免 ReactEChartsCore 因为 props 引用变化而重复 setOption
const CHART_STYLE = { width: '100%', height: '100%' };
const fmtAxisSmartTransNum = (p) => {
  if (p >= 0 && p <= 1) {
    return p;
  }
  return transNum(p);
};

const Visit = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const intl = useIntl();
  const { formatMessage } = intl;
  const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const [type, setType] = useState('WEEK');
  const { data, title, loading } = props;
  const changeType = useCallback((v) => {
    setType(v);
  }, []);
  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const chartOption = useMemo(() => {
    let xData = [];
    // const legendData = data[type].xDataList;
    let pvData = [];
    let uvData = [];

    const result = mulTimeDimensionMulIndexMulValue(data || []);
    if (type === 'WEEK') {
      for (let index = 7; index > 0; index--) {
        xData.push(dayjs().subtract(index, 'day').format('YYYY-MM-DD'));
      }
    } else {
      for (let index = 30; index > 0; index--) {
        xData.push(dayjs().subtract(index, 'day').format('YYYY-MM-DD'));
      }
    }

    xData.forEach((e) => {
      const pvDataItem = result[type]?.PV?.find((s) => s.LABEL === e) || {
        VALUE: 0,
      };
      pvData.push(pvDataItem.VALUE);
      const uvDataItem = result[type]?.UV?.find((s) => s.LABEL === e) || {
        VALUE: 0,
      };
      uvData.push(uvDataItem.VALUE);
    });
    const seriesData = [
      {
        name: 'PV',
        // name: formatMessage({ id: 'ec.dashboard.n07.lbl03' }),
        type: 'line',
        data: pvData,
        yAxisIndex: 0,
        smooth: true,
        lineStyle: {
          width: 2.5,
        },
      },
      {
        name: 'UV',
        // name: formatMessage({ id: 'ec.dashboard.n07.lbl02' }),
        type: 'line',
        yAxisIndex: 1,
        data: uvData,
        smooth: true,
        lineStyle: {
          width: 2.5,
        },
      },
    ];
    let option = {
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      tooltip: {
        trigger: 'axis',
        textStyle: {
          fontSize: chartsFontSize.s03,
        },
      },
      legend: {
        // data: ['订单金额', '订单笔数'],
        data: [
          // formatMessage({ id: 'ec.dashboard.n07.lbl03' }),
          // formatMessage({ id: 'ec.dashboard.n07.lbl02' }),
          'PV',
          'UV',
        ],
        itemWidth: 10,
        itemHeight: 10,
        top: 0,
        icon: 'rect',
      },
      grid: {
        top: 30,
        left: 10,
        right: 20,
        bottom: 0,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: xData, //['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        axisLabel: {
          color: charts.xColor, //坐标值得具体的颜色
          fontSize: chartsFontSize.s03,
          //   interval: function () {
          //     return true;
          //   },
        },
        axisTick: false,
        axisLine: {
          lineStyle: {
            color: charts.axisLineColor,
          },
        },
      },
      yAxis: [
        {
          type: 'value',
          axisTick: false,
          axisLine: false,
          axisLabel: {
            color: charts.yColor, //坐标值得具体的颜色
            fontSize: chartsFontSize.s03,
            formatter: fmtAxisSmartTransNum,
          },
          minInterval: 1,
          splitLine: {
            show: false, //去除网格线
            lineStyle: {
              color: charts.axisLineColor,
            },
          },
          nameTextStyle: {
            color: charts.yColor,
          },
          min: 0,
        },
        {
          type: 'value',
          axisTick: false,
          axisLine: false,
          axisLabel: {
            color: charts.yColor, //坐标值得具体的颜色
            fontSize: chartsFontSize.s03,
            formatter: fmtAxisSmartTransNum,
          },
          minInterval: 1,
          splitLine: {
            show: true, //去除网格线
            lineStyle: {
              color: charts.axisLineColor,
            },
          },
          nameTextStyle: {
            color: charts.yColor,
          },
          min: 0,
        },
      ],
      color: charts.lineColorAreaList,
      series: seriesData,
    };
    return option;
  }, [
    data,
    type,
    chartsFontSize.s03,
    fontFamily,
    charts.xColor,
    charts.axisLineColor,
    charts.yColor,
    charts.lineColorAreaList,
  ]);

  return (
    <>
      <Head boxId={title}>
        <TypeChangeBtnGroup
          typeList={[
            {
              label: `7${formatMessage({ id: 'comm.date.lbl.02' })}`,
              value: 'WEEK',
            },
            {
              label: `30${formatMessage({ id: 'comm.date.lbl.02' })}`,
              value: 'MONTH',
            },
          ]}
          change={changeType}
        />{' '}
      </Head>{' '}
      <Body bizData={data} loading={loading}>
        {' '}
        {/* <div className={styles.box}>
                <div className={styles.TypeChangeBtnGroup}>
                  <TypeChangeBtnGroup
                    change={changeType}
                    typeList={[
                      { label: '7天', value: 'week' },
                      { label: '30天', value: 'month' },
                    ]}
                  />
                </div>
              </div> */}{' '}
        {/* <ReactEcharts
          style={{
            width: '100%',
            height: '100%',
          }}
          option={echartsOptions || {}}
          notMerge={true}
          lazyUpdate={true}
          showLoading={false}
          // onEvents={onEvents}
        /> */}
        <ReactEChartsCore
          echarts={echarts}
          lazyUpdate={true}
          option={chartOption}
          notMerge={true}
          style={CHART_STYLE}
          showLoading={false}
        />
      </Body>{' '}
    </>
  );
};
export default Visit;
